import { Box, Grid, Slider, TextField, Typography } from '@mui/material';
import React from 'react';

import { selectedElement, updateContentElementById } from 'features/document/documentSlice';
import { useAppDispatch } from 'app/hooks';
import { colorPalette, docGeniusPalette } from 'styles/partials/colors';
import { isVideoElement } from 'utils/typeGuards';
import AlignmentRadioGroup from 'components/AlignmentRadioGroup/AlignmentRadioGroup';
import { Tag } from 'components/RadioTag/RadioTag';
import { SubtitleSize } from '../ImageSidebar/ImageSidebar.styled';

interface Props {
  currentElement: selectedElement;
}
export default function VideoSidebar({ currentElement }: Props) {
  const dispatch = useAppDispatch();
  if (!isVideoElement(currentElement.data)) {
    return null;
  }
  const { style } = currentElement.data;
  const { justifyContent } = style;
  const justifyContentOp = [
    { label: 'left', value: 'left' },
    { label: 'center', value: 'center' },
    { label: 'right', value: 'right' },
  ];
  const widthValue = Number(parseInt(currentElement.data.style.width, 10));
  const percentageWidth = Math.round(((widthValue - 10) / (560 - 10)) * 100);
  const elementStyle: Tag = justifyContentOp.find(el => el.value === justifyContent) as Tag;

  const handleYTVideo = (url: string) => {
    dispatch(
      updateContentElementById({
        content: {
          src: url,
        },
      })
    );
  };

  const handleYTVideoSize = (size: number) => {
    dispatch(
      updateContentElementById({
        content: currentElement.data.content,
        style: {
          width: `${size}`,
          height: size,
        },
      })
    );
  };

  const handleUpdateByProperty = (property: string) => {
    return (tag: Tag) => {
      dispatch(
        updateContentElementById({
          style: {
            [property]: tag.value,
          },
        })
      );
    };
  };

  return (
    <div>
      <Typography
        align='left'
        color={docGeniusPalette.primaryBlue}
        fontSize='16px'
        fontWeight={500}
        marginBottom='10px'
        variant='h4'
      >
        Embed Video
      </Typography>
      <Box
        bgcolor={colorPalette.videoContainer}
        borderRadius='8px'
        flexDirection='column'
        height='100%'
        justifyContent='start'
        padding='10px'
      >
        <Typography component='p' fontSize='14px ' fontFamily='Rubik'>
          Please provide a YouTube URL to embed in your file.
        </Typography>
        <TextField
          fullWidth
          margin='normal'
          placeholder='Add YouTube URL Video'
          sx={{ bgcolor: 'white' }}
          value={currentElement.data.content.src}
          onChange={e => handleYTVideo(e.target.value)}
        />
      </Box>
      <Typography
        align='left'
        color={docGeniusPalette.primaryBlue}
        fontSize='16px'
        fontWeight={500}
        marginBottom='10px'
        marginTop='20px'
        variant='h4'
      >
        Video Size
      </Typography>
      <SubtitleSize>{percentageWidth}%</SubtitleSize>

      <Slider
        aria-label='Size Slider'
        max={560}
        value={widthValue}
        min={10}
        size='small'
        sx={{ '.MuiSlider-thumb': { boxShadow: 'none' } }}
        onChange={(_, currentSize) => handleYTVideoSize(+currentSize)}
      />
      <Typography
        align='left'
        color={docGeniusPalette.primaryBlue}
        fontSize='16px'
        fontWeight={500}
        marginBottom='10px'
        marginTop='20px'
        variant='h4'
      >
        Alignment
      </Typography>
      <Grid item xs={9}>
        <AlignmentRadioGroup selected={elementStyle} handleChange={handleUpdateByProperty('justifyContent')} />
      </Grid>
    </div>
  );
}
